import split from 'lodash/split';
import axios from 'axios';
import _get from 'lodash/get';
import * as types from '../constants/ActionTypes';
import Page from '../../lib/page';
import { setContextApiCall } from '../../contactUs/actions/action-article';
import { isOmniChannelAPITriggeredInSession } from '../../lib/globalHelper';
import { isSetContextEnabled } from '../../lib/omnichannelHelper';
import { trackPage } from '../../lib/analytics-helper';

const ARTICLE_URL = '/smarthelp/article-content';

function requestArticle() {
  return { type: types.REQUEST_MACHINE_ARTICLE };
}

function receiveArticle(responseData) {
  return {
    type: types.RECEIVE_MACHINE_ARTICLE_RESPONSE,
    payload: responseData,
  };
}

function receiveArticleError() {
  return { type: types.RECEIVE_MACHINE_ARTICLE_ERROR };
}

export default function fetchMachineArticle({ faqId, locale }) {
  return (dispatch, getState) => {
    dispatch(requestArticle());
    const isHomePage = !!window.localStorage.getItem('isHome');
    const faq = split(faqId, ',')[0];
    let articleURL = `${ARTICLE_URL}?article_id=${faq}&isHomePage=${isHomePage}`;

    const topicDetails = _get(getState(), 'selectResult.topicTreeSelectResult', {});

    // Checking the session storage for omni channel API triggered value from session
    const setContextTriggered = isOmniChannelAPITriggeredInSession();

    if (locale) {
      articleURL = Page.setURLQuery(articleURL, 'locale', locale);
    }

    return axios
      .get(articleURL)
      .then((response) => {
        window.localStorage.removeItem('isHomePage');
        if (response.data && response.data.articleContent) {
          dispatch(receiveArticle(response.data.articleContent));

          const articleIntents = isSetContextEnabled(topicDetails, response.data);

          // Set context Validations and API call
          if (!setContextTriggered && Page.isLoggedIn()) {
            dispatch(setContextApiCall(articleIntents, faq, false));
          }
        } else if (isHomePage) {
          window.localStorage.removeItem('isHome');
          trackPage({ id: 'articleRedirect', hpid: faqId, link: 'smarthelp-article-redirect-to-home' });
          window.location.href = '/smarthelp/home';
        }
      })
      .catch(() => {
        window.localStorage.removeItem('isHomePage');
        dispatch(receiveArticleError());
      });
  };
}
